import { CSS_UNITS, IMagnitude } from "../interfaces/layouts"

export const getCssDemention = (value?: string | number, def: string = "0" ): string => {
    if(typeof value === "undefined") return def
    if(typeof value === "number") {
        return `${value}px`
    }
    return value
}

export const getCSSPartDemention = (value?: string | number, def: string = "0", part: number = 1 ): string => {
    if(typeof value === "undefined") return def
    if(typeof value === "number") {
        return `${value * part }px`
    } else {
        const numb  = parseInt(value)
        const dl    = value.replace(numb.toString(), "")
        return numb / 2 + dl
    }
}

// return "calc" css value
export const getSCSSDifference = ( value: string | number, subtrahend: string ): string => {    
    const subtrahendValue   = parseInt(subtrahend)
    const subtrahendExt     = subtrahend.replace(subtrahendValue.toString(), "") 
    if(typeof value === "number") {
        if( subtrahendExt === "px" ) {
            return (value - subtrahendValue) + "px"
        }
        return `calc(${value}px - ${subtrahend})`
    } 
    else { 
        const valueValue        = parseInt(value)
        const valueExt          = value.replace(valueValue.toString(), "")
        if(valueExt === subtrahendExt) {
            return (valueValue - subtrahendValue) + valueExt
        }
        return `calc(${value} - ${subtrahend})`
    }

}

export const getDementionData = (value: string | number): IMagnitude => {
    const valueValue        = parseInt(value.toString())
    const valueExt          = value.toString().replace(valueValue.toString(), "")
    switch(valueExt) {
        case CSS_UNITS.DVH:
        case CSS_UNITS.DVW:
        case CSS_UNITS.PERCENTAGE:
        case CSS_UNITS.VH:
        case CSS_UNITS.VW:
            return {
                value: valueValue, 
                units: valueExt
            }
        case CSS_UNITS.PX:
        case "":
        default:
            return {
                value: valueValue, 
                units: CSS_UNITS.PX
            }
    }
}